<script setup>
defineProps({
  // CSS handle position props
  maxWidth: {
    type: String,
    default: '',
  },
  top: {
    type: String,
    default: '',
  },
  bottom: {
    type: String,
    default: '',
  },
  placement: {
    type: String,
    default: '',
  },
  // CSS handle position props
});

//Choose bettween CENTER, LEFT or RIGHT
const handlePosition = (position) => {
  if (position === 'center') {
    return 'left-1/2 -translate-x-1/2';
  } else if (position === 'right') {
    return 'right-0';
  } else {
    return 'left-0';
  }
};
</script>

<template>
  <HeadlessPopover class="relative z-10 flex">
    <HeadlessPopoverButton class="rounded focus:outline-none">
      <slot name="popover-button" />
    </HeadlessPopoverButton>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <HeadlessPopoverPanel
        :class="[
          maxWidth ? `${maxWidth}` : 'max-w-xs',
          top ? `${top}` : 'top-auto',
          bottom ? `${bottom}` : 'botom-auto',
          placement ? `${handlePosition(placement)}` : 'left-1/2 -translate-x-1/2',
        ]"
        class="absolute z-10 w-screen transform rounded-xl bg-white shadow-[0px_0px_20px_0px_#8DDFF8] dark:bg-[#0F2260]"
      >
        <slot name="popover-content" />
      </HeadlessPopoverPanel>
    </transition>
  </HeadlessPopover>
</template>
